var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-empty"},[_c('InitialAvatarIcon',{staticClass:"table-empty__icon",attrs:{"icon":"ED0030","size":"large"}}),_c('BaseText',{attrs:{"size":"md","color":_vm.NebraskaColors.textSecondary}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }